(() => {
	'use strict';

	const isEditMode = () =>
		document.body.classList.contains('pimcore-editmode') ||
		document.body.classList.contains('pimcore_editmode');

	const plural = (n, forms) => {
		const a = Math.abs(n);
		if (a === 1) return forms[0];
		if (a >= 2 && a <= 4) return forms[1];
		return forms[2];
	};

	class Calculator {
		constructor(root) {
			this.root = root;

			this.config = {
				price:    Number(root.dataset.price)    || 0,
				device:   Number(root.dataset.device)   || 0,
				payment:  Number(root.dataset.payment)  || 0,
				days:     Number(root.dataset.days)     || 0,
				currency: root.dataset.currency || '',
				locale:   root.dataset.locale   || 'cs-CZ',
			};

			this.fmtInt     = new Intl.NumberFormat(this.config.locale, { maximumFractionDigits: 0 });
			this.fmtDecimal = new Intl.NumberFormat(this.config.locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });

			this.clientsWords = (root.dataset.clientsWords || '').split('|');

			this.outputs = {
				revenue:             root.querySelector('[data-out="revenue"]'),
				revenueClients:      root.querySelector('[data-out="revenue-clients"]'),
				revenueClientsWord:  root.querySelector('[data-out="revenue-clients-word"]'),
				revenueMeasurements: root.querySelector('[data-out="revenue-measurements"]'),
				revenuePrice:        root.querySelector('[data-out="revenue-price"]'),
				payback:             root.querySelector('[data-out="payback"]'),
				payment:             root.querySelector('[data-out="payment"]'),
				profit:              root.querySelector('[data-out="profit"]'),
				bar:                 root.querySelector('[data-bar="payment"]'),
			};

			this.priceInput = root.querySelector('[data-input="price"]');

			root.addEventListener('click', this.onClick);
			if (this.priceInput) this.priceInput.addEventListener('input', this.onPriceInput);

			const initial = root.querySelector('.calculator__client-btn.is-active') || root.querySelector('.calculator__client-btn');
			this.clients = initial ? Number(initial.dataset.clients) || 0 : 0;
			this.render();
		}

		onClick = (event) => {
			const button = event.target.closest('.calculator__client-btn');
			if (button && this.root.contains(button)) {
				const clients = Number(button.dataset.clients) || 0;
				if (clients <= 0) return;

				this.root.querySelectorAll('.calculator__client-btn').forEach((b) => {
					const active = b === button;
					b.classList.toggle('is-active', active);
					b.setAttribute('aria-selected', active ? 'true' : 'false');
				});
				this.clients = clients;
				this.render();
				return;
			}

			const step = event.target.closest('.calculator__price-step');
			if (step && this.root.contains(step) && this.priceInput) {
				if (step.dataset.step === 'down') {
					this.priceInput.stepDown();
				} else {
					this.priceInput.stepUp();
				}
				this.config.price = Number(this.priceInput.value) || 0;
				this.render();
			}
		};

		onPriceInput = (event) => {
			const value = Number(event.target.value);
			this.config.price = Number.isFinite(value) && value >= 0 ? value : 0;
			this.render();
		};

		render() {
			const { price, device, payment, days, currency } = this.config;
			const clients      = this.clients;
			const measurements = clients * days;
			const revenue      = measurements * price;
			const profit       = revenue - payment;
			const payback      = revenue > 0 ? device / revenue : null;
			const ratio        = revenue > 0 ? Math.min(100, (payment / revenue) * 100) : 100;

			const money = (n) => `${this.fmtInt.format(n)} ${currency}`;

			this.set(this.outputs.revenue,             money(revenue));
			this.set(this.outputs.revenueClients,      String(clients));
			this.set(this.outputs.revenueClientsWord,  plural(clients, this.clientsWords));
			this.set(this.outputs.revenueMeasurements, this.fmtInt.format(measurements));
			this.set(this.outputs.revenuePrice,        money(price));
			this.set(this.outputs.payback,             payback === null ? '—' : this.fmtDecimal.format(payback));
			this.set(this.outputs.payment,             money(payment));
			this.set(this.outputs.profit,              money(profit));

			if (this.outputs.bar) this.outputs.bar.style.width = `${ratio}%`;
			this.root.classList.toggle('is-loss', profit < 0);
		}

		set(node, value) {
			if (node) node.textContent = value;
		}
	}

	const init = () => {
		if (isEditMode()) return;
		document.querySelectorAll('.calculator:not(.calculator--vue)').forEach((root) => new Calculator(root));
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init, { once: true });
	} else {
		init();
	}
})();
